<div class="timeline" [ngClass]="{ 'timeline-violation-mode': violationMode }">
  <div class="timeline-line"></div>
  <div
    class="timeline-item"
    *ngFor="let item of timelineItems; let i = index; let last = last; let first = first"
    matTooltip="{{ item.tooltipText }}"
  >
    <div class="timeline-item-marker">
      <div *ngIf="!withIcons" class="timeline-item-marker-number">
        {{ timelineItemsDescOrder ? timelineItems.length - i : i + 1 }}
      </div>
      <img *ngIf="withIcons && item.iconPath" [src]="item.iconPath" class="timeline-item-marker-icon" />
    </div>
    <div
      class="timeline-item-text"
      [ngClass]="{
        'timeline-item-text-last': last,
        'timeline-item-text-first': first,
      }"
    >
      <div class="timeline-item-text-primary">
        {{ item.text }}
        <img
          *ngIf="item.infoTooltipText"
          src="assets/images/common/info.svg"
          class="timeline-item-info-icon"
          width="14"
          [matTooltip]="item.infoTooltipText"
          matTooltipPosition="right"
          matTooltipClass="tooltip__white tooltip__multiline"
        />
        <img
          *ngIf="item.showLightningIcon"
          src="assets/images/common/lightning.svg"
          class="timeline-item-lightning-icon"
          width="18"
          [matTooltip]="item.lightningTooltipText || ''"
          matTooltipPosition="right"
          matTooltipClass="tooltip__white tooltip__multiline"
        />
      </div>
      <div *ngIf="item.secondaryText" class="timeline-item-text-secondary">
        {{ item.secondaryText }}
      </div>
      @if (violationMode && item.nestedItems && item.nestedItems.length > 0) {
        <ul class="timeline-item-nested-list">
          @for (nestedItem of item.nestedItems; track nestedItem.text) {
            <li class="timeline-item-nested-item">
              {{ nestedItem.text }}
            </li>
          }
        </ul>
      }
    </div>
  </div>
</div>
